import { render, staticRenderFns } from "./WhenRetiring.vue?vue&type=template&id=09745807&lang=pug"
import script from "./WhenRetiring.vue?vue&type=script&lang=js"
export * from "./WhenRetiring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports